import {ConfigObjectType, DlSelectOption} from '@wallaby-ui/core';
import {sortBy} from 'lodash';
import React, {useMemo} from 'react';
import {Options} from 'react-select';
import {ValidateError} from 'src/js/common';
import {FilterSchema} from 'src/js/model/filters_config';

import {
  FilterNodeTypeHierarchySyncMultiSelectContainer,
  FilterNodeTypeHierarchySyncMultiSelectContainerProps,
} from './FilterNodeTypeHierarchySyncMultiSelectContainer';
import {useOrganizations} from '../../permissions/usePermissions';
import {getSelectOptionIdProperty} from '../filtering_helpers';

type OwnProps = Omit<
  FilterNodeTypeHierarchySyncMultiSelectContainerProps,
  'data' | 'options' | 'valueProperty' | 'hierarchyData' | 'schema'
> & {
  error?: ValidateError;
  isDefaultValue?: boolean;
  getOptionDisabled?: (row: any) => boolean;
  schema?: FilterSchema;
  disableClearable?: boolean;
  config: ConfigObjectType;
};

type Props = OwnProps;

/** @deprecated TODO: remove this, use `<LightOrganizationFilter2>` instead */
export const FilterNodeTypeOrganization: React.FC<Props> = (props) => {
  const {isMui, config, ...restProps} = props;
  const {data: organizations} = useOrganizations(config);

  const idProperty = getSelectOptionIdProperty(isMui);
  const options = useMemo<Options<DlSelectOption>>(() => {
    return sortBy(
      organizations.map((item) => {
        return {
          value: item.id.toString(),
          [idProperty]: item.id.toString(),
          label: item.organizationLongName,
          levelType: item.levelType,
        };
      }),
      'label'
    );
  }, [idProperty, organizations]);

  return (
    <FilterNodeTypeHierarchySyncMultiSelectContainer
      {...restProps}
      options={options}
      valueProperty={idProperty}
      hierarchyData={organizations}
      isMui={isMui}
    />
  );
};

FilterNodeTypeOrganization.displayName = 'FilterNodeTypeOrganization';
